import PropTypes from "prop-types";
import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

// components
import LoadingScreen from "../components/loading-screen";
//
import Login from "../pages/LoginPage";
import { useAuthContext } from "./useAuthContext";

// ----------------------------------------------------------------------
AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  // Redirect authenticated users based on their role
  if (isAuthenticated) {
    const userRole = (user?.role?.slug || user?.role || user?.user?.role?.slug || "admin").toLowerCase();

    // If user is a rider trying to access admin routes
    if (userRole === "rider" && pathname.startsWith("/admin")) {
      return <Navigate to="/rider" replace />;
    }

    // If user is an admin or staff trying to access rider routes
    if ((userRole === "admin" || userRole === "staff") && pathname.startsWith("/rider")) {
      return <Navigate to="/admin" replace />;
    }

    // Handle any requested location before auth
    if (requestedLocation && pathname !== requestedLocation) {
      setRequestedLocation(null);
      return <Navigate to={requestedLocation} replace />;
    }

    return <>{children}</>;
  }

  // Handle unauthenticated users
  if (pathname !== requestedLocation) {
    setRequestedLocation(pathname);
  }
  return <Login />;
}
